var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import classNames from "classnames";
import MaterialCheckbox from "@mui/material/Checkbox";
import { FormControlLabel } from "@mui/material";
import { Icon } from "../Icon";
// style
import "./checkbox.scss";
const defaultProps = {
    "data-testid": "tecma-checkbox",
    icon: undefined,
    size: "medium",
};
const CustomCheckbox = forwardRef((_a, ref) => {
    var { icon, checkedIcon, size, helpText, status, className } = _a, props = __rest(_a, ["icon", "checkedIcon", "size", "helpText", "status", "className"]);
    const classList = classNames({
        [`${status}`]: status,
    }, "tecma-custom-checkbox");
    const IconToShowOnCheck = icon ? (_jsx(Icon, { iconName: icon, filled: true })) : (_jsx("div", { className: "checkbox-element", children: _jsx(Icon, { iconName: "check" }) }));
    return (_jsxs("div", { className: classList, children: [_jsx(MaterialCheckbox, Object.assign({ inputRef: ref, color: "default" }, props, { icon: _jsx("div", { className: classNames("tecma-checkbox-container", size), children: icon ? _jsx(Icon, { iconName: icon }) : _jsx("div", { className: "checkbox-element" }) }), checkedIcon: _jsx("div", { className: classNames("tecma-checkbox-container", "checked", size), children: checkedIcon ? _jsx(Icon, { iconName: checkedIcon }) : IconToShowOnCheck }) })), helpText && (_jsx("span", { className: status === "error" ? "help-text-errored" : "help-text", children: helpText }))] }));
});
/**
 * An input for choosing from predefined options.
 */
const Checkbox = forwardRef((_a, ref) => {
    var { label, labelPlacement, className } = _a, rest = __rest(_a, ["label", "labelPlacement", "className"]);
    const classList = classNames("tecma-checkbox", className);
    return (_jsx(FormControlLabel, { control: _jsx(CustomCheckbox, Object.assign({ ref: ref }, rest)), label: label, labelPlacement: labelPlacement, className: classList }));
});
Checkbox.defaultProps = defaultProps;
export default Checkbox;
